<script setup lang="ts">
  import type { PopoverContentProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { PopoverContent as RekaPopoverContent } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'
  import { popoverContentVariants, popoverShadowClass, type PopoverContentVariants } from '.'

  const props = defineProps<
    PopoverContentProps & {
      class?: HTMLAttributes['class']
      side?: PopoverContentVariants['side']
      size?: PopoverContentVariants['size']
    }
  >()

  const delegatedProps = reactiveOmit(props, 'class', 'size')
</script>

<template>
  <RekaPopoverContent
    v-bind="delegatedProps"
    :class="cn(popoverContentVariants({ side: props.side, size }), popoverShadowClass, props.class)"
  >
    <div class="text-m-medium leading-relaxed text-text-body-default">
      <slot />
    </div>
    <div class="mt-3 flex justify-end gap-3 items-center">
      <slot name="footer" />
    </div>
  </RekaPopoverContent>
</template>
